import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button, Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from "react-router-dom";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import CustomFormEnumSelect from "components/select/CustomFormEnumSelect";
import CustomFormSelect from "components/select/CustomFormSelect";
import { getEquipmentCategoriesByQuery } from "components/axios/equipmentCategoryAxios";
import { extensionCheck, fileAccepts, ROLE } from 'data/data';
import { useEnumApi } from "contexts/EnumApiContext";
import { customFileAxios } from "components/axios/customAxios";
import { getEquipmentCtgr1ByZone } from "components/axios/equipmentAxios";
import usePermission from "hooks/usePermission";
import { PERMISSIONS } from "config/permissions";

const DataAddSetting = () => {
    const { getEnumValueByEnumName, equipmentCategoryLevel1s } = useEnumApi();
    const { t, i18n } = useTranslation();

    const selectOptions = useMemo(() => {
        return fileAccepts.map(item => ({
            code: item.code,
            title: t(item.titleKey),
            extension: item.extension,
        }));
    }, [t, i18n.language]); // 언어 변경 시 자동 재계산

    // modal 관련
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
        openModal(modals.alertModal, {
            onClose : () => {
                console.log(1111);
            },
            message: alertMessage,
        });
    };

    const { control, register, handleSubmit, formState : {isDirty, errors } } = useForm({});

    const navigate = useNavigate();
    const [equipmentCategory1s, setEquipmentCategory1s] = useState([]);
    const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
    const [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState('');
    const [file, setFile] = useState(null);
    const [accept, setAccept] = useState({});
    const [fileLoading, setFileLoading] = useState(false);

    useEffect(()=> {
        getEquipmentCtgr1ByZone().then((data)=>{
            setEquipmentCategory1s(data)
        })
    }, [])

    // 설비중분류 목록
    useEffect(()=>{
        if (equipmentCategoryLevel1Id) {
            const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100 , sort : "name,asc"};
            getEquipmentCategoriesByQuery(param).then((data) => {
            if (data && data._embedded) {
                const list = data._embedded.equipmentCategories;
                if (list) {
                    setEquipmentCategoryLevel2s(list);
                } else {
                    setEquipmentCategoryLevel2s([]);
                }
            } else {
                setEquipmentCategoryLevel2s([]);
            }
        });
    }
    },[equipmentCategoryLevel1Id]);

    // 등록
    let onSubmit = (data) => {
        setFileLoading(true);
        console.log(data);

        const equipmentCategoryLevel1Id = data.equipmentCategoryLevel1Id;
        const equipmentCategoryLevel2Id = data.equipmentCategoryLevel2Id;
        const fileType                  = data.fileType;
        const fileAccept                = data.fileAccept;
        const title                     = data.title;

        if (file) {
           
            if (!extensionCheck(file.name, fileAccept)) {
                handleAlertClick(t('message.common.alert.file.not.match.type'));
                setFileLoading(false);
                return;
            }
        } else {
            handleAlertClick(t('message.common.alert.file.select'));
            setFileLoading(false);
            return;
        }
        
        openModal(modals.confirmModal, {
            onSubmit : (value) => {
                let dto = {
                    equipmentCtgr : {
                        id : equipmentCategoryLevel2Id,
                        parent : {id : equipmentCategoryLevel1Id}
                    },
                    title,
                    fileType,
                    fileManagerType : "C"
                };

                let formData = new FormData();
                formData.append("files", file);
                formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );

                // for (var value1 of formData.entries()) {
                //     console.log(value1[0]+', ',value1[1]);
                // }
                try {
                    const res = customFileAxios.post(`/api/fileManagers`, formData).then((res)=>{
                        console.log(res);
                        handleAlertClick(t('message.common.alert.write.done'));
                        setFileLoading(false);
                        navigate('../'+res.data.id+window.location.search);
                    }).catch((err)=>{
                        console.log(err);
                        handleAlertClick(err.response?.data?.message || err.message);
                    });
                    // return res.data;
                } catch (error) {
                    console.error("error :", error);
                    throw error;
                }
                
            },
            onClose : () => {
                console.log('close');
                setFileLoading(false);
            },
            message: t('message.common.alert.write.question'),
        });
    };

    const { hasPermission } = usePermission();
    const canWrite  = hasPermission(PERMISSIONS.SETTING_DATAROOM_WRITE);

    return (
    <div>
      {/* <div className="mro_search">
        <h5 className="mro_m_left">* {t('menu.cmms.management.data')}</h5>
      </div> */}

      <form onSubmit={handleSubmit(onSubmit)}>
        <TableContainer>
          <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width" style={{borderTop:"2px solid #a2a2a2"}} >
            <TableBody>
              <TableRow key={0}>
                <TableCell className="th" style={{height:"70px"}}>{t('message.common.subtitle.equipment.level1')}</TableCell>
                <TableCell className="email_pl">
                    <Controller
                        sx={{ m: 1, minWidth: "90%" }}
                        aria-invalid={!isDirty ? undefined : errors.equipmentCategoryLevel1Id ? "true" : "false"}
                        control={control}
                        name="equipmentCategoryLevel1Id"
                        render={({ field: {name} }) => (
                        <CustomFormSelect
                            style={{ minWidth: '90%' }}
                            label={t('message.common.subtitle.equipment.level1')}
                            register={register}
                            name={name}
                            requiredMessage={t('message.common.error.text.level1.select')}
                            defaultValue={''}
                            onChange={(e)=>{
                                setEquipmentCategoryLevel1Id(e.target.value);
                            }}
                            list={equipmentCategory1s}
                        />
                        )}
                    />
                    {errors.equipmentCategoryLevel1Id && <small role="alert"><br></br>{errors.equipmentCategoryLevel1Id.message}</small>}
                </TableCell>
                <TableCell className="th">{t('message.common.subtitle.equipment.level2')}</TableCell>
                <TableCell className="email_pl">
                    <Controller
                        sx={{ m: 1, minWidth: "90%" }}
                        aria-invalid={!isDirty ? undefined : errors.equipmentCategoryLevel2Id ? "true" : "false"}
                        control={control}
                        name="equipmentCategoryLevel2Id"
                        render={({ field: {name} }) => (
                        <CustomFormSelect
                            style={{ minWidth: '90%' }}
                            label={t('message.common.subtitle.equipment.level2')}
                            register={register}
                            name={name}
                            requiredMessage={t('message.common.error.text.level2.select')}
                            defaultValue={''}
                            list={equipmentCategoryLevel2s}
                        />
                        )}
                    />
                    {errors.equipmentCategoryLevel2Id && <small role="alert"><br></br>{errors.equipmentCategoryLevel2Id.message}</small>}
                </TableCell>
                <TableCell className="th">{t('message.common.select.division')}</TableCell>
                <TableCell className="email_pl">
                    <Controller
                        sx={{ m: 1, minWidth: "90%" }}
                        aria-invalid={!isDirty ? undefined : errors.fileType ? "true" : "false"}
                        control={control}
                        name="fileType"
                        render={({ field: {name} }) => (
                        <CustomFormEnumSelect
                            style={{ minWidth: '90%' }}
                            label={t('message.common.select.division')}
                            register={register}
                            name={name}
                            requiredMessage={t('message.common.error.text.division.select')}
                            defaultValue={''}
                            list={getEnumValueByEnumName("FileType")}
                        />
                        )}
                    />
                    {errors.fileType && <small role="alert"><br></br>{errors.fileType.message}</small>}
                </TableCell>
              </TableRow>
              <TableRow key={1}>
                <TableCell className="th" style={{height:"70px"}}>{t('message.common.subtitle.title')}</TableCell>
                <TableCell colSpan={3} className="email_pl">
                    <TextField 
                        aria-invalid={!isDirty ? undefined : errors.title ? "true" : "false"}
                        {...register("title", {
                            required : t('message.common.error.text.title.input')
                        })} 
                        defaultValue={''}
                        sx={{ m: 1, minWidth: '90%'}}
                    />
                    {errors.title && <small role="alert"><br></br>{errors.title.message}</small>}
                </TableCell>
                <TableCell className="th">{t('message.common.subtitle.type2')}</TableCell>
                <TableCell className="email_pl">
                    <Controller
                        sx={{ m: 1, minWidth: "90%" }}
                        aria-invalid={!isDirty ? undefined : errors.fileAccept ? "true" : "false"}
                        control={control}
                        name="fileAccept"
                        render={({ field: {name} }) => (
                        <CustomFormEnumSelect
                            style={{ minWidth: '90%' }}
                            label={t('message.common.subtitle.type2')}
                            register={register}
                            name={name}
                            requiredMessage={t('message.common.error.text.type2.select')}
                            defaultValue={''}
                            onChange={(e)=>{
                                let accept = fileAccepts.filter(item => item.code === e.target.value);
                                console.log(accept);
                                setAccept(accept[0]);
                            }}
                            list={selectOptions}
                        />
                        )}
                    />
                    <br></br>{accept.extension}
                    {errors.fileAccept && <small role="alert"><br></br>{errors.fileAccept.message}</small>}
                </TableCell>
              </TableRow>
              <TableRow key={2}>
                <TableCell className="th" style={{height:"70px"}}>{t('message.common.subtitle.file')}</TableCell>
                <TableCell colSpan={5} className="email_pl">
                    <input
                        type="file" 
                        accept={accept.extension}
                        onChange={(e)=>setFile(e.target.files[0])}
                    />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </form>

      <div style={{marginTop:"10px", display:"flex", justifyContent:"space-between"}}>
        <div><Link to={'/setting/data/dataroom'+window.location.search}><Button variant="contained" color="primary">{t('message.common.btn.list')}</Button></Link></div>
        {canWrite && 
        <div>
          <LoadingButton variant="contained" color="primary" loading={fileLoading} onClick={handleSubmit(onSubmit)}>{t('message.common.btn.write')}</LoadingButton>
        </div>
        }
      </div>
    </div>
    )
}

export default DataAddSetting;